// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"BtnCart_btnContainer__1qunn","btnCart":"BtnCart_btnCart__2V62Q","divContainer":"BtnCart_divContainer__-twUt"};